export default __webpack_public_path__ + "static/media/FPT.aab4733f.svg";